module.exports = __webpack_public_path__ + "img/node.19cb6853.png";